//富文本处理
export const format_html = (html)=>{
	let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
	    match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
	    match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
	    match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
	    return match;
	  });
	  newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
	    match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
	    return match;
	  });
	  newContent = newContent.replace(/<br[^>]*\/>/gi, '');
	  newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"');
	  return newContent;
}
//随机数
export const mt_rand = (min=0, max=100)=>{
	 return Math.floor(Math.random() * (max - min + 1) + min)
}
//手机号格式化
export const format_tel = (tel = '')=>{
	if(empty(tel)){
		return false;
	}
	return String(tel).slice(0,3) + '****' + String(tel).slice(-4)
}
/**
 * 验证手机格式
 */
 export const mobile = function(value) {
	return /^1[23456789]\d{9}$/.test(value)
}